export default __webpack_public_path__ + "static/media/gallery-wip-emitter_07.54e06501.jpg";